export default {
  // -------------  BASE ALONSO    ----------------------
  apiKey: 'AIzaSyB2ohwLTBQGWgLl7YBmsXYiG2-ajyyb72c',
  authDomain: 'buro-app.firebaseapp.com',
  databaseURL: 'https://buro-app.firebaseio.com',
  projectId: 'buro-app',
  storageBucket: 'buro-app.appspot.com',
  messagingSenderId: '458461905971',
  appId: '1:458461905971:web:7617b973897e3453998f46',
  measurementId: 'G-3P1884KHPC'
  // -------------  BASE ALONSO    ----------------------
  // -------------  TESTING DANIEL    ----------------------
  // apiKey: 'AIzaSyBkJfq52EGjY7XqvMbnmgnh-o2AI4St1Gs',
  // authDomain: 'drntss.firebaseapp.com',
  // databaseURL: 'https://drntss.firebaseio.com',
  // projectId: 'drntss',
  // storageBucket: 'drntss.appspot.com',
  // messagingSenderId: '618964320957',
  // appId: '1:618964320957:web:6953dda9b2f9ccd25aedd4',
  // measurementId: 'G-CPJ4B3D45T'
  // -------------  TESTING DANIEL    ----------------------
  // -------------  TESTING VALERIA    ----------------------
  // apiKey: "AIzaSyABwfMdpmGDF8ZkYweI_MEJeERUPbS85Kw",
  // authDomain: "wowtheapp1.firebaseapp.com",
  // databaseURL: "https://wowtheapp1.firebaseio.com",
  // projectId: "wowtheapp1",
  // storageBucket: "wowtheapp1.appspot.com",
  // messagingSenderId: "931244297358",
  // appId: "1:931244297358:web:0f3a418adfc408a4b80ddf"
  // -------------  TESTING VALERIA    ----------------------
}
